module.exports = __webpack_public_path__ + "static/media/facebook.6dec7010.svg";